/**
 * @fileoverview GET handler for the Decisioning Studio Agent Preferences endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdAgentPreferences } from "./constants";
import type {
  GetDecisioningStudioAgentsAppGroupIdDsaIdAgentPreferencesParams,
  GetDecisioningStudioAgentsAppGroupIdDsaIdAgentPreferencesResult,
} from "./types";
import { isGetDecisioningStudioAgentsAppGroupIdDsaIdAgentPreferencesResult } from "./validators";

export const getDecisioningStudioAgentsAppGroupIdDsaIdAgentPreferences = reactQueryFetcherAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdAgentPreferences,
  (
    signal: AbortSignal,
    {
      appGroupId,
      dsaId,
      startDate,
      endDate,
      dimension,
      regimes,
    }: GetDecisioningStudioAgentsAppGroupIdDsaIdAgentPreferencesParams
  ): Promise<GetDecisioningStudioAgentsAppGroupIdDsaIdAgentPreferencesResult> => {
    return fetch(
      `/decisioning_studio_agents/${appGroupId}/${dsaId}/agent_preferences`,
      "GET",
      {
        start_date: startDate,
        end_date: endDate,
        dimension,
        regimes,
      },
      { signal },
      {
        propagateFetchRequestError: false,
      }
    );
  },
  isGetDecisioningStudioAgentsAppGroupIdDsaIdAgentPreferencesResult
);
